import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";
import { Router } from "@angular/router";

import { tap, map, catchError } from "rxjs/operators";
import { MasterftpForm } from "../../interfaces/masterftp-form.interface";

const masterFtpTestUrlApi = environment.masterFtpTestUrlApi;
const masterFtpCreateUrlApi = environment.masterFtpCreateUrlApi;

@Injectable()
export class MasterFtpService {
  constructor(private router: Router, private http: HttpClient) {}

  testFtp(masterFtpModel: MasterftpForm) {
    console.log(masterFtpModel);
    // delete clientModel.active;
    const body = masterFtpModel;
    return this.http
      .request("POST", `${masterFtpTestUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  createMasterFtp(masterFtpModel: MasterftpForm) {
    console.log(masterFtpModel);
    const body = masterFtpModel;
    return this.http
      .request("POST", `${masterFtpCreateUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }
}
